import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { onEnterObservacio } from '../../actions';
import selectorDetallObservacio from '../../selectors/selector_observacio_per_codi';

import ObservacioData from './observacioData';
import ObservacioMapa from './observacioMapa';
import ObservacioDetall from './observacioDetall';
import ObservacioBotoExportacio from './observacioBotoExportacio';
import errorBoundaryWrapper from '../commons/errorBoundaryWrapper';

/**
 * Component que mostra tota la informació de la vista d'observacions
 */
class Observacions extends Component {
    componentDidMount() {
        this.props.onEnterObservacio();
    }

    render() {
        const { observacio } = this.props;
        return (
            <div className="observacio">
                {<div className='observacio-boto-exportacio-area'>
                    <ObservacioBotoExportacio />
                </div>}
                <div className="observacio-data-area">
                    <ObservacioData />
                </div>
                <div className="observacio-mapa-area">
                    <ObservacioMapa />
                </div>
                <div className="observacio-detall-area">
                    {observacio ? <ObservacioDetall observacio={observacio} /> : null}
                </div>
            </div>
        );
    }
}

Observacions.propTypes = {
    observacio: PropTypes.object,
    onEnterObservacio: PropTypes.func
};

const mapStateToProps = state => ({
    observacio: selectorDetallObservacio(state)
});

export default errorBoundaryWrapper(
    connect(
        mapStateToProps,
        { onEnterObservacio }
    )(Observacions)
);



// WEBPACK FOOTER //
// ./src/components/observacio/observacio.js